export default __webpack_public_path__ + "static/media/streak-tier-2.cea6430b.png";